import { useSelector } from "react-redux";
import { ApplicationState } from "../../store";
import { useMemo } from "react";
import { UserInfo } from "../../store/auth/types";
import { getFullName } from "../NamesUtils";
import { useIntl } from "react-intl";

const useCreatedBy = (user?: Pick<UserInfo, 'id' | 'first_name' | 'last_name'>) => {
  const userInfo = useSelector((s: ApplicationState) => s.auth.userInfo);
  const intl = useIntl();

  const platformName = useMemo(
    () => "ReadyCoach",
    []
  );

  const createdBy = useMemo(() => {
    if (!user) return platformName;
    if (user.id === (userInfo && userInfo.id)) {
      return "Me";
    } else {
      return getFullName(user);
    }
  }, [user, userInfo, platformName]);

  return { platformName, createdBy };
};

export default useCreatedBy;
